

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const REGISTRATIONPROFILEGETBYID= createAsyncThunk(
  "RegistrationProfileGetById/RegistrationProfileGetById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const RegistrationProfileGetByIdSlice = createSlice({
  name: "RegistrationProfileGetByIdSlice",
  initialState: {
    RegistrationProfileGetById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfRegistrationProfileGetById: (state) => {
        state.RegistrationProfileGetById.loading = false
        state.RegistrationProfileGetById.error = false
        state.RegistrationProfileGetById.data = []
        state.RegistrationProfileGetById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(REGISTRATIONPROFILEGETBYID.fulfilled, (state, action) => {
      state.RegistrationProfileGetById = {
        ...state.RegistrationProfileGetById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REGISTRATIONPROFILEGETBYID.pending, (state, action) => {
      state.RegistrationProfileGetById = {
        ...state.RegistrationProfileGetById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REGISTRATIONPROFILEGETBYID.rejected, (state, action) => {
      state.RegistrationProfileGetById = {
        ...state.RegistrationProfileGetById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const RegistrationProfileGetByIdAction = {
    REGISTRATIONPROFILEGETBYID,
};

export { RegistrationProfileGetByIdAction };
export default RegistrationProfileGetByIdSlice.reducer;
export const {setInitialStateOfRegistrationProfileGetById} = RegistrationProfileGetByIdSlice.actions
